module.exports = __webpack_public_path__ + "img/440_69_011_730.2a500386.jpg";